import { render, staticRenderFns } from "./PatientQuickAdd.vue?vue&type=template&id=0002beaa&scoped=true"
import script from "./PatientQuickAdd.vue?vue&type=script&lang=js"
export * from "./PatientQuickAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002beaa",
  null
  
)

export default component.exports